import React from "react"
import DocumentView from "components/DocumentView"

const sections = [
  {
    name: "About",
    children: [
      {
        name: "About Camps and Campers",
        subtitle: "Learn more about camps and campers.",
        route: "/about",
        component: require("./pages/about").default,
      },
      {
        name: "Our History",
        subtitle: "Learn about how we began.",
        route: "/about/history",
        component: require("./pages/history").default,
      },
      {
        name: "How the Site Works",
        subtitle: "Explore the features of our site.",
        route: "/about/site",
        component: require("./pages/howSiteWorks").default,
      },
    ],
  },

  {
    name: "For Families",
    children: [
      {
        name: "Why Summer Camp?",
        subtitle: "Explore the benefits of attending a summer camp.",
        route: "/about/features/families",
        component: require("./pages/whySummerCamp").default,
      },
      {
        name: "Why Camps and Campers?",
        subtitle: "Discover the advantages of using this site.",
        route: "/about/features/families/value",
        component: require("./pages/whyCS").default,
      },
      {
        name: "How to Find a Summer Camp?",
        subtitle:
          "Learn how to find the best summer camp that fits your needs.",
        route: "/about/features/families/how",
        component: require("./pages/howToFind").default,
      },
    ],
  },

  {
    name: "For Camps",
    children: [
      {
        name: "Features for Camps",
        subtitle: "Find out why camps should use this site.",
        route: "/about/features/camps",
        component: require("./pages/features").default,
      },
      {
        name: "Our Value to Camps",
        subtitle: "Learn about the value we bring to camps.",
        route: "/about/features/camps/value",
        component: require("./pages/value").default,
      },
      {
        name: "Pricing",
        route: "/about/features/camps/pricing",
        subtitle: "Learn about our membership pricing.",
        component: require("./pages/none").default,
      },
      {
        name: "Sample Camper Profile",
        subtitle: "View an example of a camp's profile page",
        route: "/about/features/camps/sample",
        component: require("./pages/none").default,
      },
    ],
  },
]

const About = props => <DocumentView sections={sections} />

export default About



// WEBPACK FOOTER //
// ./src/scenes/About/index.js